import { ExternalLink, Globe } from 'lucide-react';

import buttonStyles from '@/components/ui/Button.module.css';
import { cx } from '@/lib/cx';

import styles from './PublicPagePanel.module.css';

type PublicPagePanelProps = {
  title: string;
  description: string;
  href: string;
  label: string;
};

export function PublicPagePanel({ title, description, href, label }: PublicPagePanelProps) {
  return (
    <section className={styles.panel}>
      <div className={styles.info}>
        <span className={styles.icon}>
          <Globe size={20} aria-hidden="true" />
        </span>
        <div>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
      <a
        className={cx(buttonStyles.btn, buttonStyles.ghost, styles.link)}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        {label}
        <ExternalLink size={16} aria-hidden="true" />
        <span className="visually-hidden"> (opens in a new tab)</span>
      </a>
    </section>
  );
}
